import { BaseData } from './base-data'
import { NotificationID } from './id/notification_id'
import { NotificationRecipientID } from './id/notification-recipient-i-d'
import TenantId from './id/tenant-id'
import { NotificationTemplateID } from './id/notification_template_id'
import { NotificationDispatchID } from './id/notification_dispatch_id'

export interface DeliveryChannelTemplateBase {
  enabled?: boolean
  body?: string
}

export interface DeliveryChannelTemplateEmail
  extends DeliveryChannelTemplateBase {
  subject?: string
}
export interface DeliveryChannelTemplateSMS
  extends DeliveryChannelTemplateBase {}
export interface DeliveryChannelTemplateWeb
  extends DeliveryChannelTemplateBase {
  subject?: string
}

export interface NotificationTemplate extends BaseData<NotificationTemplateID> {
  notificationType: NotificationType
  name: string
  description: string
  config: {
    emailTemplate: DeliveryChannelTemplateEmail
    webTemplate: DeliveryChannelTemplateWeb
    smsTemplate: DeliveryChannelTemplateSMS
  }
  tenantID: TenantId
}

export interface Notification extends BaseData<NotificationID> {
  status: 'READ' | 'SENT'
  subject?: string
  body: string
}

export interface NotificationRecipient
  extends BaseData<NotificationRecipientID> {
  name: string
  description: string
  type: NotificationRecipientType
  configuration: NotificationRecipientConfig
  tenantID: TenantId
}

export interface NotificationRecipientConfig
  extends Partial<PlatformUsersNotificationRecipientConfig> {
  type: NotificationRecipientConfigType
}

export interface PlatformUsersNotificationRecipientConfig {
  userFilter: UsersFilter
}

export interface UsersFilter
  extends Partial<
    UserListFilter & CustomerUsersFilter & TenantAdministratorsFilter
  > {
  type: NotificationRecipientConfigType
}

interface UserListFilter {
  usersIDs: Array<string>
}

interface CustomerUsersFilter {
  customerID: string
}

interface TenantAdministratorsFilter {
  tenantsIDs?: Array<string>
  tenantProfilesIDs?: Array<string>
}

export interface SlackNotificationRecipientConfig {
  conversationType: SlackChanelType
  conversation: SlackConversation
}

export enum SlackChanelType {
  PUBLIC_CHANNEL = 'PUBLIC_CHANNEL',
  PRIVATE_CHANNEL = 'PRIVATE_CHANNEL',
  DIRECT = 'DIRECT',
}

export interface SlackConversation {
  id: string
  title: string
  name: string
  wholeName: string
  email: string
  type: string
}

export interface MicrosoftTeamsNotificationRecipientConfig {
  webhookUrl: string
  channelName: string
}

export enum NotificationRecipientType {
  USER = 'USER',
  SLACK = 'SLACK',
  MICROSOFT_TEAMS = 'MICROSOFT_TEAMS',
}

export enum NotificationRecipientConfigType {
  ALL_USERS = 'ALL_USERS',
  TENANT_ADMINISTRATORS = 'TENANT_ADMINISTRATORS',
  CUSTOMER_USERS = 'CUSTOMER_USERS',
  USER_LIST = 'USER_LIST',
  USER_GROUP_LIST = 'USER_GROUP_LIST',
  ORIGINATOR_ENTITY_OWNER_USERS = 'ORIGINATOR_ENTITY_OWNER_USERS',
  AFFECTED_USER = 'AFFECTED_USER',
  SYSTEM_ADMINISTRATORS = 'SYSTEM_ADMINISTRATORS',
  AFFECTED_TENANT_ADMINISTRATORS = 'AFFECTED_TENANT_ADMINISTRATORS',
}

export enum NotificationType {
  GENERAL = 'GENERAL',
  RULE_NODE = 'RULE_NODE',
  ENTITY_ACTION = 'ENTITY_ACTION',
}

export interface NotificationDispatch extends BaseData<NotificationDispatchID> {
  recipientIDs: NotificationRecipientID[]
  templateID: NotificationTemplateID
}
